import React, { Fragment } from 'react';
import Text from '../../../../common/form/Text';

export const RenderHeaderMessage = () => {

    return (
        <Fragment>
            <Text
                classes={['margin-t-5-ve']}
                id="info_message"
                text="selfDesignation.attestation.verifyConsumerIdentity.message"
                display='block'
            />
        </Fragment>
    );

};